(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player-solidtango/assets/javascripts/stream-player-solidtango.js') >= 0) return;  svs.modules.push('/components/racing/stream-player-solidtango/assets/javascripts/stream-player-solidtango.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef
} = React;
const Icon = svs.ui.ReactIcon;
const {
  urlMapping
} = svs.core;
const {
  StreamPlayerThumbnailFull,
  StreamPlayerPreview
} = svs.components.racing.streamPlayerSolidtangoPreview;
const {
  VideoPlayer
} = svs.components.video_player;
const loadVideo = svs.components.video_player.contentLoader.loadVideo;
const {
  VODContext
} = svs.racing;
const {
  StreamPlayerSolidtangoError
} = svs.components.racing.streamPlayerSolidtango;
const {
  useNavigationState
} = svs.racing.navigation;
const {
  buildLocation
} = svs.racing.navigation.location;
const {
  racingStreamAssetId
} = svs.racing.streamplayer_solidtango.data;
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const isMobile = svs.core.detect.formfactor.mobile();
const logger = new svs.core.log.Logger('components:racing:stream-player-solidtango:stream-player-solidtango');
const StreamPlayerSolidtango = _ref => {
  let {
    showLive,
    vodFromQuery
  } = _ref;
  const navState = useNavigationState();
  const {
    currentVOD,
    setCurrentVOD
  } = useContext(VODContext);
  const headerButtonsRef = useRef(null);
  const [showThumbnail, setShowThumbnail] = useState(true);
  const [goToLive, setGoToLive] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [loadedVideo, setLoadedVideo] = useState(null);
  const [folded, setFolded] = useState(!showLive && isMobile);
  const [assetId, setAssetId] = useState(vodFromQuery ? vodFromQuery : racingStreamAssetId); 
  const showPlayer = !hasError && assetId && loadedVideo && !showThumbnail;
  const showErrorMessage = isLoggedIn && hasError;
  if (!assetId) {
    setHasError(true);
  }
  const toggleFolded = () => {
    setFolded(!folded);
  };
  const getHeaderInfo = () => {
    if (currentVOD) {
      const {
        date,
        track,
        raceNumber
      } = currentVOD;
      return "".concat(date, ", ").concat(track, ", ").concat(raceNumber ? "Lopp ".concat(raceNumber) : '');
    }
    return '';
  };
  const displayCloseVODBtn = opacity => {
    var _headerButtonsRef$cur;
    if (headerButtonsRef !== null && headerButtonsRef !== void 0 && (_headerButtonsRef$cur = headerButtonsRef.current) !== null && _headerButtonsRef$cur !== void 0 && _headerButtonsRef$cur.style) {
      headerButtonsRef.current.style.opacity = opacity;
    }
  };
  const loadStreamingPlayer = useCallback(() => {
    if (!isLoggedIn) {
      const {
        pathname,
        search
      } = buildLocation(_objectSpread(_objectSpread({}, navState), {}, {
        showLive: true,
        showLiveRedirect: true,
        assetId: currentVOD === null || currentVOD === void 0 ? void 0 : currentVOD.assetId
      }));
      const returnUrl = "".concat(urlMapping.get('racing')).concat(pathname).concat(search);
      svs.components.customer_login.login({
        returnUrl
      });
    }
    const playerSettings = {
      type: 'solidtango',
      videoId: assetId,
      height: 360,
      width: 640,
      title: getHeaderInfo(),
      api: true,
      autoplay: true
    };
    loadVideo(playerSettings, (err, model) => {
      if (err) {
        logger.warn('Something went wrong while loading the video player.', err);
        setHasError(true);
      } else {
        setLoadedVideo(model);
        setShowThumbnail(false);
      }
    });
  }, [assetId, currentVOD === null || currentVOD === void 0 ? void 0 : currentVOD.assetId, navState]);
  const renderPlayer = () => React.createElement(VideoPlayer, {
    height: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.height,
    jsonLDTags: true,
    src: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.src,
    title: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.title,
    videoId: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId,
    width: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.width
  });
  useEffect(() => {
    if (!currentVOD && currentVOD !== null && currentVOD !== void 0 && currentVOD.assetId) {
      setHasError(true);
    }
    if (vodFromQuery && (currentVOD === null || currentVOD === void 0 ? void 0 : currentVOD.assetId) === undefined) {
      setAssetId(vodFromQuery);
    }
    if (currentVOD && (currentVOD === null || currentVOD === void 0 ? void 0 : currentVOD.assetId) !== assetId) {
      setAssetId(currentVOD === null || currentVOD === void 0 ? void 0 : currentVOD.assetId);
    }
  }, [currentVOD, assetId, vodFromQuery]);
  useEffect(() => {
    if (!currentVOD && goToLive) {
      setAssetId(racingStreamAssetId);
      loadStreamingPlayer();
    }
    if (assetId && assetId !== racingStreamAssetId) {
      loadStreamingPlayer();
    }
  }, [assetId, currentVOD, goToLive, loadStreamingPlayer]);
  useEffect(() => {
    if (showLive) {
      loadStreamingPlayer();
    }
  }, [loadStreamingPlayer, showLive]);
  const renderMobile = () => {
    if (showErrorMessage && folded) {
      return React.createElement(StreamPlayerSolidtangoError, {
        loadStreamingPlayer: loadStreamingPlayer
      });
    }
    if (folded && showThumbnail) {
      return React.createElement(StreamPlayerPreview, {
        toggleFolded: toggleFolded
      });
    }
    if (showPlayer) {
      return renderPlayer();
    }
    if (!folded) {
      return React.createElement(StreamPlayerThumbnailFull, {
        isMobile: isMobile,
        loadStreamingPlayer: loadStreamingPlayer,
        toggleFolded: toggleFolded
      });
    }
  };
  const renderDesktop = () => {
    if (showErrorMessage) {
      return React.createElement(StreamPlayerSolidtangoError, {
        loadStreamingPlayer: loadStreamingPlayer
      });
    }
    if (showThumbnail) {
      return React.createElement(StreamPlayerThumbnailFull, {
        isMobile: isMobile,
        loadStreamingPlayer: loadStreamingPlayer
      });
    }
    if (showPlayer) {
      return renderPlayer();
    }
  };
  if (!isSelfService) {
    return React.createElement("div", {
      className: "stream-player-solidtango",
      onMouseLeave: () => {
        displayCloseVODBtn('0');
      },
      onMouseMove: () => {
        displayCloseVODBtn('1');
      }
    }, showPlayer && (currentVOD === null || currentVOD === void 0 ? void 0 : currentVOD.assetId) && React.createElement("div", {
      className: "stream-player-solidtango__header-buttons",
      onClick: () => {
        setCurrentVOD(undefined);
        setGoToLive(true);
      },
      ref: headerButtonsRef
    }, React.createElement(Icon, {
      color: "icon-inverted",
      icon: "close",
      size: "400"
    })), isMobile ? renderMobile() : renderDesktop());
  }
  return null;
};
setGlobal('svs.components.racing.streamPlayerSolidtango.StreamPlayerSolidtango', StreamPlayerSolidtango);

 })(window);